import store from '@/store';

export const modalPlugin = {
  install(Vue) {
    if (!store) {
      console.error('Vuex store is required for the notification plugin!');
      return;
    }
    Vue.prototype.$modal = {
      async open(component, parameters = {}) {
        await store.dispatch('openModal', { component, parameters });
      },
      async close() {
        await store.dispatch('closeModal');
      }
    };
  }
};
